<template>
  <div class="detail-wrapper">
    <div class="report-detail-wrapper" :class="{ dark: night }">
      <van-loading v-if="loading" size="20px">加载中...</van-loading>
      <div v-else>
        <h2 class="title">{{ article.title }}</h2>
        <div class="meta">
          <span v-if="article.source" class="meta-source">{{ article.source }}</span>
          <span v-if="article.author" class="meta-source">{{ article.author }}</span>
          <span class="meta-time">{{ formatDate(article.time) }}</span>
        </div>
        <DetailPdfEntry
          :file-url="pdfUrl"
          :title="article.title"
          label="点击查看研报pdf原文"
          :night="night"
        ></DetailPdfEntry>
        <div v-if="article.content" class="detail-content" v-dompurify-html="article.content"></div>
        <Empty v-else></Empty>
        <div class="disclaimer">{{ disclaimer }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { materialDetailPage } from '@/api/b2b-news';
import { disclaimer } from '@/views/detailPage/utils/article';
import { getQsid } from '@/views/detailPage/utils/qsid';
import DetailPdfEntry from '@/views/detailPage/components/DetailPdfEntry/DetailPdfEntry.vue';
import Empty from '@/views/detailPage/components/Empty';
import dayjs from 'dayjs';
import { Loading } from 'vant';

const TIMESTAMP_SECOND_LENGTH = 10;

export default {
  name: 'DetailPageReport',
  components: {
    [DetailPdfEntry.name]: DetailPdfEntry,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
  },
  data() {
    return {
      loading: false,
      lang: '',
      article: {
        title: '',
        content: '',
      },
      disclaimer,
    };
  },
  computed: {
    night() {
      return window.navigator.userAgent.indexOf('hxtheme/1') > -1 || this.$route.query?.theme === 'black';
    },
    pdfUrl() {
      if (this.article.pdfUrl) {
        return this.article.pdfUrl;
      }
      return Array.isArray(this.article.sourceUrl) ? this.article.sourceUrl[0] || '' : '';
    },
  },
  mounted() {
    this.initLang();
    this.getDetail();
  },
  methods: {
    initLang() {
      const lang = this.$route.query.lang?.toLowerCase();
      this.lang = lang === 'tw' ? 't' : lang || '';
    },
    getDetail() {
      const { id } = this.$route.params;
      const { accessKey } = this.$route.query;
      const usid = getQsid();
      const params = {
        contentId: id,
        ...this.lang ? { lang: this.lang } : {},
        ...usid ? { u: usid } : {},
        ...accessKey ? { accessKey } : {},
      };

      this.loading = true;
      materialDetailPage(params).then(res => {
        const { code, data, disclaimer: qsDisclaimer } = res;
        if (code === 0 && data) {
          this.article = {
            ...data,
            content: this.formatContent(data.content),
          };
          this.disclaimer = qsDisclaimer || disclaimer;
          this.changeTitle(data.title);
        } else {
          this.resetArticle();
        }
      }).catch(() => {
        this.resetArticle();
      }).finally(() => {
        this.loading = false;
      });
    },
    formatContent(content = '') {
      if (!content || this.hasHtmlTag(content)) {
        return content;
      }
      const paragraphs = content
        .replace(/\u3000/g, '')
        .split(/\r?\n/)
        .map(item => item.trim())
        .filter(Boolean);
      return paragraphs.length ? `<p>${paragraphs.join('</p><p>')}</p>` : '';
    },
    hasHtmlTag(content) {
      return /<\/?[a-z][\s\S]*>/i.test(content);
    },
    resetArticle() {
      this.article = {
        title: '',
        content: '',
      };
      this.changeTitle();
    },
    changeTitle(title) {
      window.document.title = title || '研报';
    },
    formatDate(value) {
      if (!value) {
        return '';
      }
      const val = Number(value);
      const time = value.toString().length === TIMESTAMP_SECOND_LENGTH ? dayjs.unix(val) : dayjs(val);
      return time.isValid() ? time.format('YYYY-MM-DD HH:mm') : '';
    },
  },
};
</script>

<style lang="less" scoped>
.detail-wrapper {
  min-height: 100vh;
}

.report-detail-wrapper {
  min-height: calc(100% - 30px);
  padding: 15px;
  background-color: #ffffff;
  color: #333333;
  font-size: 16px;
  line-height: 24px;

  .title {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    line-height: 30px;
    word-break: break-all;
  }

  .meta {
    display: flex;
    flex-wrap: wrap;
    margin-top: 15px;
    color: #a3a3a3;
    font-size: 14px;

    &-source {
      margin-right: 10px;
    }
  }

  .detail-content {
    margin-top: 15px;
    word-break: break-all;
  }

  .disclaimer {
    margin-top: 30px;
    line-height: 22px;
    font-size: 12px;
    color: #a3a3a3;
  }
}

.van-loading {
  height: 100vh;
  line-height: 100px;
  text-align: center;
}

.dark {
  background-color: #121212;
  color: #d2d2d2;

  .title {
    color: #d2d2d2;
  }

  .meta {
    color: #a9a9a9;
  }

  .disclaimer {
    color: #8e8e8e;
  }

  .van-loading {
    background-color: #121212;
  }
}
</style>
<style lang="less">
.report-detail-wrapper {
  .detail-content {
    p {
      margin-top: 10px;
      word-break: break-word;
    }

    img {
      width: 100% !important;
    }

    a {
      display: none;
    }

    .brokers_hidden {
      display: none;
    }
  }
}
</style>
